import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import LRU from '../../utils/lrucache/lrucache';

var ImpressionObserver = /*#__PURE__*/function () {
  function ImpressionObserver(size, hasher) {
    _classCallCheck(this, ImpressionObserver);

    this.cache = new LRU(size);
    this.hasher = hasher;
  }

  _createClass(ImpressionObserver, [{
    key: "testAndSet",
    value: function testAndSet(impression) {
      if (!impression) return null;
      var hash = this.hasher(impression);
      var previous = this.cache.get(hash);
      this.cache.set(hash, impression.time);
      return previous;
    }
  }]);

  return ImpressionObserver;
}();

export default ImpressionObserver;